import { Card, CardContent } from "@mui/material";
import type { ReactNode } from "react";
import {
  pageFilterPanelContentSx,
  pageFilterPanelSx,
} from "../../lib/ui/formLayout";
import AppFormGrid from "./AppFormGrid";

type Props = {
  children: ReactNode;
  spacing?: "default" | "compact";
  alignItems?: "flex-start" | "center" | "flex-end" | "stretch";
};

/** Compact filter/toolbar strip — single outlined surface, dense field grid. */
export default function PageFilterPanel({
  children,
  spacing = "compact",
  alignItems = "center",
}: Props) {
  return (
    <Card variant="outlined" sx={pageFilterPanelSx}>
      <CardContent sx={pageFilterPanelContentSx}>
        <AppFormGrid spacing={spacing} alignItems={alignItems}>
          {children}
        </AppFormGrid>
      </CardContent>
    </Card>
  );
}
